var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 48,
    viewBox: "0 0 37 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19219 37.8H27.8078V34.2H9.19219V37.8ZM9.19219 27.6H27.8078V24H9.19219V27.6ZM3.46875 48C2.54375 48 1.73437 47.64 1.04062 46.92C0.346875 46.2 0 45.36 0 44.4V3.6C0 2.64 0.346875 1.8 1.04062 1.08C1.73437 0.36 2.54375 0 3.46875 0H24.3391L37 13.14V44.4C37 45.36 36.6531 46.2 35.9594 46.92C35.2656 47.64 34.4562 48 33.5312 48H3.46875ZM22.6047 14.76H33.5312L22.6047 3.6V14.76Z",
    fill: "#1773BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.9f1d3dc383015684d85ce736310315ae.svg";
export { ForwardRef as ReactComponent };